<script setup lang="ts">
import { type FragmentType, graphql } from '@/gql';
import { PlaceholderableImg } from '#shared/components/misc';
import { useRoutes } from '@glow/shared/lib/routes';

const blogPostFragment = graphql(/* GraphQL */ `
  fragment MasterBlogPost_BlogPostFragment on BlogPost {
    id
    slug
    title
    coverUrl
    categories {
      id
      name
    }
  }
`);

const props = defineProps<{
  post: FragmentType<typeof blogPostFragment>;
}>();

const post = useFragmentData(blogPostFragment, () => props.post);
const { getUrl } = useRoutes();
</script>

<template>
  <NuxtLink
    :to="getUrl('blogPost', { slug: post.slug })"
    class="page-card post p-3 d-flex flex-column gap-1"
  >
    <PlaceholderableImg
      class="post__cover"
      :src="post.coverUrl"
      background-color="white"
    />
    <div class="text-black-secondary">
      {{ post.categories[0]?.name }}
    </div>
    <div class="text-black font-bold">
      {{ post.title }}
    </div>
  </NuxtLink>
</template>

<style scoped lang="scss">
.post {
  background: var(--app-color-accent-tertiary);

  &__cover {
    aspect-ratio: 16 / 9;
    border-radius: var(--app-br-sm);
  }
}
</style>
